export default {
  image: {
    type: '图片只能是 JPG/PNG 格式',
    sizeLt2M: '图片大小不能超过 2MB'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/public/file.js